module.exports = __webpack_public_path__ + "img/paibian-mu.f58b9f48.jpg";